import React from 'react';
import { z } from 'zod';
import { RecurringRateBasedSchedule, ScheduleUnitSchema } from '@glueapp/graph-types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useId } from 'react';

interface ScheduleEditorProps {
    value: RecurringRateBasedSchedule;
    onChange: (updatedSchedule: RecurringRateBasedSchedule) => void;
}

export const RateInput: React.FC<ScheduleEditorProps> = ({ value, onChange }) => {
    const handleUnitChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const scheduleUnit = ScheduleUnitSchema.safeParse(event.target.value);
        if (!scheduleUnit.success) {
            return;
        }
        onChange({ ...value, unit: scheduleUnit.data });
    };

    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = z.number().int().positive().safeParse(Number(event.target.value));
        if (!newValue.success) {
            return;
        }
        onChange({ ...value, value: newValue.data });
    };

    const labelId = useId();

    return (
        <div className="flex items-center gap-2">
            <Label htmlFor={labelId} className="text-xs shrink-0">
                Every
            </Label>
            <Input id={labelId} type="number" value={value.value} onChange={handleValueChange} className="w-20" />
            <Select
                value={value.unit}
                onValueChange={value => handleUnitChange({ target: { value } } as React.ChangeEvent<HTMLSelectElement>)}
            >
                <SelectTrigger className="w-28">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="MINUTE">Minutes</SelectItem>
                    <SelectItem value="HOUR">Hours</SelectItem>
                    <SelectItem value="DAY">Days</SelectItem>
                    <SelectItem value="WEEK">Weeks</SelectItem>
                    <SelectItem value="MONTH">Months</SelectItem>
                    <SelectItem value="YEAR">Years</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
};
